export enum GoalProgressStatus {
  AHEAD = "AHEAD",
  BEHIND = "BEHIND",
  CRITICAL = "CRITICAL"
}
